import { render, staticRenderFns } from "./verifyMail.vue?vue&type=template&id=71149566&scoped=true&"
import script from "./verifyMail.vue?vue&type=script&lang=js&"
export * from "./verifyMail.vue?vue&type=script&lang=js&"
import style0 from "./verifyMail.vue?vue&type=style&index=0&id=71149566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71149566",
  null
  
)

export default component.exports